import React from 'react'
import FilterListbox from './FilterListbox'
import {
  Refinement,
  SelectedRefinements,
  ToggleFilterType
} from '../ProductList.types'
import { getBaseCategory } from '../index'

type FiltersProps = {
  className?: string
  refinements: Refinement[]
  mobile?: boolean
  selectedRefinements: SelectedRefinements
  toggleFilter: ToggleFilterType
}

export const EXCLUDED_REFINEMENTS = ['ID', 'orderable_only']
export const ALLOWED_SUBCATEGORIES = ['tea', 'accessories']

const Filters = ({
  className = '',
  refinements,
  mobile,
  selectedRefinements,
  toggleFilter
}: FiltersProps) => {
  return (
    <div
      className={`grid grid-cols-1 gap-x-5 gap-y-2 md:grid-cols-3 md:gap-x-7 md:gap-y-4 lg:grid-cols-4 xl:grid-cols-5 ${className}`}
    >
      {refinements?.map((filter) => {
        if (
          EXCLUDED_REFINEMENTS.includes(filter.attributeId) ||
          !filter.values ||
          (filter.attributeId === 'cgid' &&
            !ALLOWED_SUBCATEGORIES.includes(getBaseCategory(filter)?.value))
        ) {
          return null
        }
        return (
          <FilterListbox
            mobile={mobile}
            key={filter.attributeId}
            filter={filter}
            toggleFilter={toggleFilter}
            selectedFilters={
              selectedRefinements[filter?.attributeId]?.split('|') || []
            }
          />
        )
      })}
    </div>
  )
}

export default Filters
